const USER_FACING_READ_RETRY_DELAYS_MS = [250, 700] as const;

function normalizeQueryErrorMessage(error: unknown) {
  if (!(error instanceof Error)) {
    return '';
  }

  return error.message.trim().toLowerCase();
}

export function isRetryableUserFacingReadError(error: unknown) {
  const message = normalizeQueryErrorMessage(error);
  if (!message) {
    return false;
  }

  if (
    message.includes('unauthorized') ||
    message.includes('forbidden') ||
    message.includes('invalid') ||
    message.includes('not found') ||
    message.includes('required')
  ) {
    return false;
  }

  return (
    message.includes('timed out') ||
    message.includes('timeout') ||
    message.includes('failed to fetch') ||
    message.includes('fetch failed') ||
    message.includes('network') ||
    message.includes('load failed') ||
    message.includes('temporar') ||
    message.includes('503') ||
    message.includes('502') ||
    message.includes('504')
  );
}

export function retryUserFacingReadQuery(failureCount: number, error: unknown) {
  return failureCount < 2 && isRetryableUserFacingReadError(error);
}

export function getUserFacingReadRetryDelay(attemptIndex: number) {
  return (
    USER_FACING_READ_RETRY_DELAYS_MS[attemptIndex - 1] ??
    USER_FACING_READ_RETRY_DELAYS_MS[
      USER_FACING_READ_RETRY_DELAYS_MS.length - 1
    ]
  );
}
